export const buildEventsAttendanceFilterGroups = (filterOptions = {}) => [
  {
    id: 'venue',
    label: 'Venue',
    filters: [
      {
        id: 'venue_name',
        label: 'Venue',
        type: 'multi-select',
        options: (filterOptions.venue_options || []).map((v) => ({ value: v, label: v })),
      },
    ],
  },
  {
    id: 'attendance',
    label: 'Attendance',
    filters: [
      {
        id: 'attendance_rate',
        label: 'Attendance Rate',
        type: 'range',
        options: [],
      },
    ],
  },
];
